/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { Cell, Grid, Heading, HFlow, Icon, InfoLabel } from 'bold-ui'
import { formatDate } from 'util/date/formatDate'

interface AcompanhamentoCondicaoSaudeVisitaDomiciliarAccordionPanelProps {
  dataUltimasVisitasDomiciliares: LocalDate[]
  qtdVisitasDomiciliares: number
}

export function AcompanhamentoCondicaoSaudeVisitaDomiciliarAccordionPanel({
  dataUltimasVisitasDomiciliares,
  qtdVisitasDomiciliares,
}: Readonly<AcompanhamentoCondicaoSaudeVisitaDomiciliarAccordionPanelProps>) {
  return (
    <Grid gap={0} alignItems='baseline' style={styles.content}>
      <Cell size={12} style={styles.item}>
        <HFlow hSpacing={0.5} alignItems='center'>
          <Icon icon='houseFilled' size={1} />
          <Heading level={4}>Visitas domiciliares (últimos 36 meses)</Heading>
        </HFlow>
      </Cell>
      <Cell size={3}>
        <InfoLabel title='Quantidade'>{qtdVisitasDomiciliares}</InfoLabel>
      </Cell>
      <Cell size={3}>
        <InfoLabel title='Últimas visitas' placeholder='-'>
          {dataUltimasVisitasDomiciliares?.map(formatDate).join(' e ')}
        </InfoLabel>
      </Cell>
    </Grid>
  )
}

const styles = {
  content: css`
    margin: 0;
    padding-top: 0.25rem;
  `,
  item: css`
    padding: 0.5rem 0 0;
  `,
}
